export default function IconBoleto(props) {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_45_1506"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="62"
        height="62">
        <rect width="62" height="62" fill="white" />
      </mask>
      <g mask="url(#mask0_45_1506)">
        <path
          d="M3.875 52.9582V42.6248H6.45833V50.3748H14.2083V52.9582H3.875ZM47.7917 52.9582V50.3748H55.5417V42.6248H58.125V52.9582H47.7917ZM10.3333 46.4998V15.4998H15.5V46.4998H10.3333ZM18.0833 46.4998V15.4998H20.6667V46.4998H18.0833ZM25.8333 46.4998V15.4998H31V46.4998H25.8333ZM33.5833 46.4998V15.4998H41.3333V46.4998H33.5833ZM43.9167 46.4998V15.4998H46.5V46.4998H43.9167ZM49.0833 46.4998V15.4998H51.6667V46.4998H49.0833ZM3.875 19.3748V9.0415H14.2083V11.6248H6.45833V19.3748H3.875ZM55.5417 19.3748V11.6248H47.7917V9.0415H58.125V19.3748H55.5417Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
